/*eslint-disable*/ export const messages = JSON.parse(
    '{"ads.title.mlt":"Mer som dette","ads.title.personal":"Personlige anbefalinger","ads.title.popular":"Populære annonser"}',
);
